module.exports = __webpack_public_path__ + "img/14.f1e8c0cd.png";